// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__q_D88","icon":"SortAdornment_icon__1z9bp","up":"SortAdornment_up__21f8f","down":"SortAdornment_down__3HGKS","active":"SortAdornment_active__2BH9s"};